module.exports = __webpack_public_path__ + "img/2.a.b165a789.png";